import styled from "styled-components";
import { deviceSpec } from "breakpoints";
import Grid from "@mui/material/Grid";
import { Paper } from "@mui/material";

export const StyledFooter = styled(Paper)`
  grid-area: 2/1;
  grid-column: 1 / -1;
  background-color: ${({ theme }) => theme.name === 'light-theme' ? theme.colors.white : theme.colors.background};
  padding: 0;
  margin: 0;
  z-index: 1;
  bottom: 0;
  height: 51px;
  align-items: center;
  width: 100%;
  display: flex;
  justify-content: space-between;
  border-radius: 0 !important;
  z-index: 6;

  > span {
    padding: 0 1em;
  }

  .corporate-logo {
    display: none;
  }

  .footer-link {
    color: ${({ theme }) => theme.colors.textColor};
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    margin: 24px 16px;
    text-decoration: none;
  }

  .footer-link:hover {
    color: grey;
  }

  .copyright-text {
    color: ${({ theme }) => theme.colors.textColor};
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 22px;
    text-align: right;
    right: 32px;
  }

  @media ${deviceSpec.isTablet} {
    .corporate-logo {
      display: block;
      margin: 8px 16px;
    }

    .footer-link {
      font-size: 12px;
    }

    .copyright-text {
      text-align: left;
    }

    justify-content: space-evenly;
  }

  @media ${deviceSpec.isMobile} {
    padding: 0;
    flex-direction: column;
  }
`;
